import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { ProblemSolution } from "@/components/landing/ProblemSolution";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Privacy } from "@/components/landing/Privacy";
import { Gallery } from "@/components/landing/Gallery";
import { AboutFaq } from "@/components/landing/AboutFaq";
import { Footer } from "@/components/landing/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Nutzerbedingungen from "@/pages/Nutzerbedingungen";
import Faq from "@/pages/Faq";

function Landing() {
  return (
    <div className="App min-h-screen bg-cream font-sans text-petrol">
      <Header />
      <main>
        <Hero />
        <ProblemSolution />
        <Features />
        <HowItWorks />
        <Privacy />
        <Gallery />
        <AboutFaq />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/nutzerbedingungen" element={<Nutzerbedingungen />} />
        <Route path="/faq" element={<Faq />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
